import { useEffect } from 'react';
import { TradeMode } from '@shared/types/frontend/trade';
import { CovalentBalanceItem } from '@shared/types/frontend';
import { IUserERC20Balance } from '@shared/types/frontend/assetPage';
import FullScreenGuard from '@/components/auth/FullScreenGuard';
import SwapHomeMobile from '@/components/trade/swap-home/SwapHomeMobile';
import { useSwap } from '@/contexts/SwapProvider';
import SlidingModal from '@/components/home/mobile/SlidingModal';
import Loading from '@/components/shared/Loading';
interface Props {
  isOpen: boolean;
  onClose: () => void;
  tradeMode: TradeMode;
  setTradeMode: (mode: TradeMode) => void;
  tradedAsset: CovalentBalanceItem;
  portfolioBalance: IUserERC20Balance;
  fromPortfolio?: boolean;
}
const SwapMobileController = (p: Props) => {
  const {
    fromAssets,
    toAssets,
    setFromAssets,
    setToAssets,
    resetAssets
  } = useSwap();
  const isLoading = p.tradeMode === TradeMode.BUY && !toAssets[0] || p.tradeMode === TradeMode.SELL && !fromAssets[0] || p.tradeMode === TradeMode.SWAP && p.tradedAsset && (p.fromPortfolio ? !fromAssets?.[0] : !toAssets?.[0]);
  useEffect(() => {
    if (p.isOpen && p.tradedAsset) {
      if (p.tradeMode === TradeMode.BUY) {
        setToAssets([p.tradedAsset]);
      } else if (p.tradeMode === TradeMode.SELL) {
        setFromAssets([p.tradedAsset]);
      } else if (p.tradeMode === TradeMode.SWAP) {
        p.fromPortfolio ? setFromAssets([p.tradedAsset]) : setToAssets([p.tradedAsset]);
      }
    }
  }, [p.isOpen, p.tradeMode, p.tradedAsset]);
  const handleClose = () => {
    resetAssets();
    p.setTradeMode(TradeMode.SWAP);
    p.onClose();
  };
  return <SlidingModal isOpen={p.isOpen} onClose={handleClose} heightFit data-sentry-element="SlidingModal" data-sentry-component="SwapMobileController" data-sentry-source-file="SwapMobileController.tsx">
      {isLoading ? <div className='flex items-center justify-center h-[50vh] pb-10'>
          <Loading />
        </div> : <FullScreenGuard>
          <SwapHomeMobile onClose={handleClose} tradeMode={p.tradeMode} />
        </FullScreenGuard>}
    </SlidingModal>;
};
export default SwapMobileController;